export default __webpack_public_path__ + "static/media/28-1.4ed6b33f.mp3";